module.exports = __webpack_public_path__ + "static/media/laptop1.8948f0b9.jpg";